import { PageHeader } from 'antd'
import React from 'react'
import HpReceiptList from '../../components/enrollment/hp/HpReceiptList'
import AdminBreadCrumb from '../../components/layout/AdminBreadCrumb'

const HpEnrollmentReceiptList = () => {

  return (
<div>


<div className="inside-main-content">
      <AdminBreadCrumb />

      <div className="box-style">
        <PageHeader
          ghost={false}
          onBack={() => window.history.back()}
          title="High Performance Or Junior High Performance List"
          subTitle=""
          
        ></PageHeader>

       
        <div className='tableView'>
          <div className="form-content">
              <HpReceiptList />
          </div>
        </div>

      </div>
    </div>

    </div>







  )
}

export default HpEnrollmentReceiptList